import posthog from "posthog-js";
import { isStagingDeploy } from "@/shared/deployTarget";

let initialized = false;

export function shouldCaptureAnalytics(): boolean {
  return (
    import.meta.env.PROD &&
    !import.meta.env.DEV &&
    !isStagingDeploy() &&
    Boolean(import.meta.env.VITE_POSTHOG_KEY)
  );
}

export function initPostHog(): void {
  if (!shouldCaptureAnalytics()) {
    return;
  }

  const key = import.meta.env.VITE_POSTHOG_KEY;
  const host = import.meta.env.VITE_POSTHOG_HOST;

  if (!key) return;

  posthog.init(key, {
    api_host: host ?? "https://eu.i.posthog.com",
    person_profiles: "identified_only",
  });
  initialized = true;
}

export function isPostHogInitialized(): boolean {
  return initialized;
}

export function capturePostHogEvent(
  event: string,
  properties: Record<string, unknown>,
): void {
  posthog.capture(event, properties);
}
